module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('a', {
    staticClass: "top_logo",
    attrs: {
      "href": '/' + _vm.Language + '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eurotrader_logo_rgb_purple.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered",
    attrs: {
      "id": "forgotPasswordFormContainer"
    }
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("forgot").tUpper()))]), _c('br'), _vm._v(_vm._s(_vm.$t("password").tUpper()))]), _vm._v(" "), _c('div', {
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "forgotPwInfo"
    }
  }, [_vm._v(_vm._s(_vm.$t("forgot_password_q").tTitle()) + " " + _vm._s(_vm.$t("forgot_password_form_instruction").tTitle()))]), _vm._v(" "), _c('form', {
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateCaptcha($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    class: {
      'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t("email").tTitle()) + "*")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.email),
      expression: "data.body.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary login",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("submit").tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "is-center"
  }, [_c('span', {
    staticClass: "select is-small lang"
  }, [_c('language')], 1), _vm._v(" "), _c('a', {
    staticClass: "is-small",
    attrs: {
      "href": "https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("risk_disclosure").tTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })])])])]), _vm._v(" "), _c('error-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad07f9a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ForgotPassword.vue
// module id = 798
// module chunks = 0